import styled from "styled-components";
import { Colors } from "../../config/Constants";
import { MakeBar } from "./MakeBar";
import { graphObject, calculateGraph } from "./graphHelper";

type GraphProps = {
  dashboardGraphArray: graphObject[];
};
export const Graph = ({ dashboardGraphArray }: GraphProps) => {
  const colorsList = ["#ED9A55", "#64A9EC", "#E7676A", "#68C8BA", "#F6CB4A"];
  let heightCount: number = calculateGraph(dashboardGraphArray);
  return (
    <LayoutContainer>
      <StyledBox>
        <StyledText>Outlets by Revenue</StyledText>
        <StyledBoxContainer>
          <MainContainer>
            {dashboardGraphArray.slice(0, 5).map((val, idx) => (
              <MakeBar
                key={idx}
                height={(val.revenue / heightCount) * 300}
                color={colorsList[idx]}
                name={val.outlet_name}
              />
            ))}
          </MainContainer>
          <BlackLine />
          <TextContainer>
            {dashboardGraphArray.slice(0, 5).map((val, idx) => (
              <StyledFlexText key={idx}>{val.revenue}</StyledFlexText>
            ))}
          </TextContainer>
        </StyledBoxContainer>
      </StyledBox>
    </LayoutContainer>
  );
};

const LayoutContainer = styled.div`
  display: flex;
  margin-top: 2.125rem;
`;

const StyledBox = styled.div`
  border-radius: 8px;
  background-color: rgba(204, 204, 204, 0.3);
  width: 100%;
  height: 35.813rem;
  @media only screen and (max-width: 768px) {
    height: auto;
    background-color: transparent;
  }
`;

const StyledBoxContainer = styled.div`
  height: 27.375rem;
  display: flex;
  flex-direction: column;
  padding: 0 5rem;

  @media only screen and (max-width: 768px) {
    background-color: rgba(204, 204, 204, 0.3);
    padding: 1rem;
    height: 15rem;
  }
`;

const BlackLine = styled.div`
  width: 100%;
  border: 1px dashed #cccccc;
`;

const MainContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  width: 100%;
  height: 100%;
`;

const TextContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: baseline;
  width: 100%;
`;

const StyledText = styled.div`
  display: flex;
  flex-direction: row;
  padding: 2.5rem 0 0 2.5rem;
  font-family: "Poppins-Medium";
  color: ${Colors.black};
  font-weight: 500;
  font-size: 1.25rem;
  font-style: normal;
  @media only screen and (max-width: 768px) {
    padding: 0;
    font-size: 0.875rem;
    margin-bottom: 1rem;
  }
`;

const StyledFlexText = styled.p`
  color: #999999;
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1.5rem;
  margin: 0;
  padding-top: 0.7rem;
  @media only screen and (max-width: 1200px) {
    font-size: 1.125rem;
  }
  @media only screen and (max-width: 768px) {
    font-size: 0.5rem;
    padding-top: 0.25rem;
    line-height: 0.5rem;
  }
`;
